<template>
    <div class="popup-ebay">
        <span class="popup-ebay__title">
            Как начать <br>
            экспортировать <br>
            свои товары <br>
            через eBay <br>
        </span>
        <a :href="$store.state.links.ebay" class="popup-ebay__logo" target="_blank">
            <img class="popup-ebay__logo-img" src="@/assets/images/ebay-logo.svg" alt="Логотип">
        </a>
        <p class="popup-ebay__desc">
            Если вы создаете что-то своими руками или владеете небольшим (или большим) производством, выходите за
            пределы страны. На eBay
            <a class="popup-ebay__desc-link" href="https://pikabu.ru/story/_vastauzhskooroskoepaitsotaekdogo_alvo__aysle_3876093" target="_blank">
                больше 183 млн покупателей
            </a>
            по всему миру, среди которых точно найдутся те, кому нужны ваши товары. Чтобы начинать было нетрудно и нестрашно,
            eBay поддерживает своих продавцов и даст всю необходимую информацию для старта.
        </p>
        <div class="popup-ebay__items">
            <div class="popup-ebay__item">
                <a class="popup-ebay__item-link" target="_blank" href="https://pikabu.ru/story/dofeni_byodivlytsyi_d_onv_onloolnaest_veshaet_5280145">
                    Первые
                    <br> шаги
                </a>
            </div>
            <div class="popup-ebay__item">
                <a class="popup-ebay__item-link" target="_blank" href="https://pikabu.ru/story/bubm_rglyceqbubnayenanocebxeniobre_sv_tovo002_5280145">
                    Основы
                    <br> продаж
                </a>
            </div>
            <div class="popup-ebay__item">
                <a class="popup-ebay__item-link" target="_blank" href="https://pikabu.ru/story/botromnul_so_soi_p_sobotdedm_sdey_nebrael_so__5280145">
                    Истории успеха <br>
                    продавцов <br class="mobile">
                    eBay
                </a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        methods: {}
    }
</script>

<style lang="stylus" scoped>
    .popup-ebay {
        max-width 86.2rem
        padding 2.6rem 4.7rem
        box-sizing border-box
        display flex
        flex-wrap wrap
        +layout-sm() {
            padding 0
        }

        &__title {
            margin-top 0.5rem
            padding-left 1rem
            font-size 4rem
            line-height 4.2rem
            font-weight $font-bold
            color #382AEF
            +layout-sm() {
                font-size 2.6rem
                line-height 2.8rem
            }
            +layout-xs() {
                padding-left: 0
                margin-top 1.9rem
            }
        }

        &__logo {
            margin-left auto
            margin-top 1.3rem
            align-self flex-start

            &:hover {
                opacity 0.8
            }

            &:active {
                opacity 0.6
            }

            &-img {
                width 15.6rem
                +layout-sm() {
                    width 6.7rem
                }
            }
            +layout-sm() {
                margin-right 3rem
            }
            +layout-xs() {
                width 80%
                order -1
                margin: 0
            }
        }

        &__desc {
            padding-left 1rem
            margin 2rem 0 0 0
            width 100%
            font-size 1.7rem
            line-height 2.3rem
            max-width 56.6rem

            &-link {
                color #382AEF
                font-weight $font-bold
                cursor pointer
                transition opacity 0.3s ease

                &:hover {
                    opacity 0.8
                }

                &:active {
                    opacity 0.6
                }
            }
            +layout-sm() {
                font-size 1.5rem
                line-height 2.4rem
            }
            +layout-xs() {
                padding-left: 0
                margin-top 1.4rem
            }
        }

        &__items {
            display flex
            margin 3rem -1rem 0 -1rem
            flex-grow 1
            +layout-sm() {
                flex-direction column
                margin-left 0
                margin-right 0
            }
            +layout-xs() {
                margin-top 0.7rem
            }
        }

        &__item {
            padding 0 1rem
            width calc(100% / 3)
            display flex
            +layout-sm() {
                width 100%
                margin-top 0.9rem
                padding 0
            }
        }

        &__item-link {
            padding 2.1rem 3rem 2.1rem 3.2rem
            height 14.6rem
            width 100%
            background-color #382AEF
            font-size 2.2rem
            line-height 2.6rem
            color #C5E5FB
            font-weight $font-bold
            background-image url('~@/assets/images/icon-arrow.svg')
            background-repeat no-repeat
            background-position right 1.5rem bottom 19px
            +layout-sm() {
                height 7.6rem
                font-size 2rem
                line-height 2.4rem
                padding 1.3rem 1.7rem
                background-position right 1.5rem center
            }

            & + & {
                margin-left 2rem
                +layout-sm() {
                    margin-left 0
                }
            }

            .mobile {
                +layout-sm() {
                    display none
                }
            }
        }
    }
</style>
